export const CLASS_NAMES = {
	setupList: 'mt-12 flex flex-col gap-1.5'
} as const;

export const STEP_CONTENT_CLASS_NAMES = {
	stepBody: 'pb-5 px-14',
	stepSubtitle: 'text-sm mb-2 font-normal text-[#64748B]',
	formStack: 'flex flex-col gap-4 mt-[33px]',
	formLabel: 'mb-2 block text-base font-bold font-semibold text-[#153059]',
	input:
		'h-10 rounded-sm border-[#AEB8C7] bg-white px-2 text-base text-[var(--color-primary-900)] placeholder:text-[#B7C0CE] focus:border-[var(--color-primary-600)]',
	textArea:
		'min-h-[82px] rounded-sm border-[#AEB8C7] bg-white px-2 py-2 font-bold text-[var(--color-primary-900)] placeholder:text-[#B7C0CE] focus:border-[var(--color-primary-600)]',
	fieldHint: 'mt-2 text-xs leading-4 text-[#52637A]',
	nextButton:
		'inline-flex h-12 min-w-[58px] items-center justify-center gap-1 rounded-full px-6 py-0 font-bold text-white transition-colors hover:bg-[var(--color-primary-800)]'
} as const;
